import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconBooking = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	viewBox: "0 0 13 16",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		clipPath: "url(#a)",
		children: /* @__PURE__ */ _jsx("path", { d: "M2.786.571A2.786 2.786 0 0 0 0 3.357v9.286a2.786 2.786 0 0 0 2.786 2.786H13V13.57h-.929v-1.857H13V.571H2.786Zm0 11.143h7.428v1.857H2.786a.928.928 0 1 1 0-1.857Zm.928-7.428h6.5v.928h-6.5v-.928Zm6.5 1.857v.928h-6.5v-.928h6.5Z" })
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "a",
		children: /* @__PURE__ */ _jsx("path", {
			fill: "#fff",
			d: "M0 .571h13v14.857H0z"
		})
	}) })]
});
export default SvgIconBooking;
